import { Button, Modal, ModalHeader, ModalBody, Col, Row,} from 'reactstrap';
import { useState } from 'react';
import '../assets/style/ViewDocumentModal.css';
import { useDispatch, useSelector } from "react-redux";
import PdfViewer from '../components/PDFViewer';
import { downloadMsgFile } from '../api/grievancesApi';
import "../assets/style/modal.css"
import {  Tooltip } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ViewDocumentModal = (props: any) => {
  const { viewDoc, openModal } = props;
  const [imagesrc, setImageSrc] = useState('');
  const [imageType, setImageType] = useState('');
  const [imageName, setImageName] = useState('');
  const [openImage, setOpenImage] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);

  const {
    storeGrievanceDocData,
  } = useSelector((state: any) => state.grievances);
  const dispatch: any = useDispatch();

  const docdata: any[] = storeGrievanceDocData ?? [];

  const sortedDocData = [...docdata].sort((a, b) => {
    const nameA = a?.fileName?.split('.')[0]?.toLowerCase() || '';
    const nameB = b?.fileName?.split('.')[0]?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });

  const closeBtn = (
    <img src={require('../assets/img/close_modal.svg').default} style={{ cursor: 'pointer' }} onClick={() => { viewDoc(); }}></img>
  );


  const closeImgBtn = (
    <img src={require('../assets/img/close_modal.svg').default} style={{ cursor: 'pointer' }} onClick={() => { showDocument(undefined, false); }}></img>
  );

  const showDocument = (image: any, flag: boolean) => {
    if(['msg', 'eml', 'doc', 'docx', 'xls', 'xlsx']?.includes(image?.fileName?.split('.')[1])) {
      let grievanceId = image?.fileName.split('.')[0]?.split('_')[0];
      let fileName = image?.fileName;
      dispatch(downloadMsgFile(grievanceId, fileName))
    }
    else {
      if (flag) {
        setImageSrc(image.documentUrl)
        setImageType(image?.fileName.split('.')[1])
        setImageName(image?.fileName.split('.')[0])
      }
      setOpenImage(!openImage)
      setOpenPDF(!openPDF)
    }
  }

  return (
    <>
      <Modal isOpen={openModal} toggle={viewDoc} centered={true} backdrop={'static'}>
        <ModalHeader toggle={viewDoc} close={closeBtn}>Documents</ModalHeader>
        <ModalBody>
         <div className='note-message'>
            * Note: Preview not supported for .xls, .xlsx, .doc, .docx, .msg, .eml. Download only..
          </div>
          <div className="final-resolution-note d-flex justify-content-center align-items-center gap-2 text-start w-100" >
              <CheckCircleIcon sx={{fontSize: "1.2rem"}} className="text-success" />
              <span>A green tick mark indicates the Final Resolution Document.</span>
            </div>
          {sortedDocData?.length == 0 && <p style={{ fontWeight: '600', textAlign: 'center' }}>No Documents Uploaded</p>}
            <Row>
              {sortedDocData?.map((each: any, i: number) => (
                <Col key={i} xs={6} md={6} className="mb-4">
                  {each.frrdoc ? (
                    <Button
                      onClick={() => showDocument(each, true)}
                      className="view-doc-button d-flex align-items-center gap-2 text-start"
                    >
                      <Tooltip title="Final Resolution Letter" placement="bottom">
                        <CheckCircleIcon
                          className="text-success"
                      />
                      </Tooltip>
                      <span className='flex-grow-1 doc-text-wrap'>
                        {each.fileName.split('.')[0]}
                      </span>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => showDocument(each, true)}
                      className="view-doc-button"
                    >
                      {each.fileName.split('.')[0]}
                    </Button>
                  )}
                </Col>
              ))}
            </Row>
        </ModalBody>
      </Modal>

      {imageType === 'pdf' &&
        <Modal isOpen={openPDF} toggle={() => { showDocument(undefined, false); }} centered={true} backdrop={'static'} size='lg'>
          <ModalHeader close={closeImgBtn} style={{ textTransform: 'capitalize' }}>{imageName}</ModalHeader>
          <ModalBody>
            <PdfViewer pdfUrl={imagesrc} />
          </ModalBody>
        </Modal>
      }
      {['jpg', 'jpeg', 'png'].includes(imageType) && 
        <Modal isOpen={openImage} toggle={() => { showDocument(undefined, false); }} centered={true} backdrop={'static'} size='xl'>
          <ModalHeader close={closeImgBtn} style={{ textTransform: 'capitalize' }}>{imageName}</ModalHeader>
          <ModalBody style={{ display: 'flex', justifyContent: 'center' }}>
            <img src={imagesrc} className='image' />
          </ModalBody>
        </Modal>
      }

    </>
  );
}


export default ViewDocumentModal;